/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const resendOTPRequestRequestSchema = z.object({
	otp_id: z.uuid(),
});
